import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// --- Link Your Real Project Files ---
// 1. Link your actual useAuth hook from your AuthProvider.
import { useAuth } from "../Hooks/AuthProvider"; 

// 2. Link your SignInForm component.
import SignInForm from "../Components/SignInForm";

// 3. Link your logo image.
import logo from "../img/logo.png";

// 4. Link your CSS file.
import "./LogIn.css";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
// --- End of Links ---

const LogIn = () => {
  // This now uses your REAL useAuth hook from the AuthProvider
  const { user, loading, onLogin } = useAuth();
  const [loginWithEmail, setLoginWithEmail] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);
  const location = useLocation();

  // Initialize Firebase Functions
  useEffect(() => {
    const functions = getFunctions();
    if (process.env.NODE_ENV === "development") {
      connectFunctionsEmulator(functions, "localhost", 5001);
    }
  }, []);

  // Get user role when user is authenticated
  useEffect(() => {
    const getUserRole = async () => {
      if (!user) {
        setRoleLoading(false);
        return;
      }

      try {
        const functions = getFunctions();
        const getUserRoleFunction = httpsCallable(functions, "getUserRole");
        const response = await getUserRoleFunction();
        setUserRole(response.data.role);
      } catch (error) {
        console.error("[LogIn] Error getting user role:", error);
        setUserRole(null);
      } finally {
        setRoleLoading(false);
      }
    };

    getUserRole();
  }, [user]);

  useEffect(() => {
    const removePopup = (e) => {
      if (e.target.id === "login-container" || e.key === 'Escape') {
        setLoginWithEmail(false);
      }
    };
    document.addEventListener("mousedown", removePopup);
    document.addEventListener("keydown", removePopup);
    return () => {
      document.removeEventListener("mousedown", removePopup);
      document.removeEventListener("keydown", removePopup);
    };
  }, []);

  // --- THE CRUCIAL FIX ---

  // 1. First, check if the AuthProvider is still loading.
  //    If it is, we wait by rendering a loading message. This prevents premature redirects.
  if (loading || roleLoading) {
    console.log('[LogIn Page] Auth provider is loading. Waiting...');
    return (
      <div id="login-container">
        <h2>Loading Application...</h2>
      </div>
    );
  }

  // 2. After loading is finished, check if a user exists.
  if (user) {
    // If user is a customer, redirect to customer portal
    if (userRole === "customer") {
      console.log('[LogIn Page] Customer user detected, redirecting to customer portal.');
      return <Navigate to="/customer/project-equipment" replace />;
    }
    // Employee users go to their intended destination or calendar
    const from = location.state?.from?.pathname || "/calendar";
    console.log(`[LogIn Page] Auth loaded and user exists. Redirecting to "${from}".`);
    return <Navigate to={from} replace />;
  }
  
  // 3. If loading is done and there's no user, render the real login UI.
  console.log('[LogIn Page] Auth loaded, no user. Rendering login buttons.');
  return (
    <div id="login-container">
      <img className="welcome-image" alt="Logo" src={logo}></img>
      <h1 className="buttons">
        <button className="login-with-google-btn" onClick={onLogin}>
          Log in with Google
        </button>
        <button
          className="login-with-email-btn"
          onClick={() => setLoginWithEmail(true)}
        >
          Log in with email
        </button>
      </h1>
      {loginWithEmail ? <SignInForm onExitPopup={setLoginWithEmail} /> : null}
    </div>
  );
};

export default LogIn;

